import * as Yup from 'yup'

const regex = /^(image\/.*|video\/.*|audio\/.*|application\/pdf)$/

export const mediaUploadValidation = Yup.string().test('fileFormat', '', (value) => {
  if (!value) return true
  return regex.test(value)
})
